import { POI_CUD } from "../../actionTypes/actionsTypes";
import { ActionPayload, AppAction, AppNoApiAction, BaseAsyncReducerState } from "../../types";

export interface POICudState extends BaseAsyncReducerState {
    success: boolean;
    method: string;
}

// Define an initial state value for the app
const initialState: POICudState  = {
    loading: false,
    error: false,
    success: false,
    method: ""
}


function POICudReducer(state = initialState, action: AppAction | AppNoApiAction) {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case POI_CUD.PENDING:
            return {
                ...state,
                loading: true,
                error: false
            }
        case POI_CUD.SUCCESS:
            return {
                ...state,
                ...payload as ActionPayload,
                loading: false,
                error: false

            }
        case POI_CUD.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        default:
            return state
        }
}

export default POICudReducer;